





























import Vue, { PropType } from 'vue';
import TableToolTotalRow from '@/components/table/newTable/TableToolTotalRow.vue';
import TableToolPerPage from '@/components/table/newTable/TableToolPerPage.vue';
import TableToolColumns from '@/components/table/newTable/TableToolColumns.vue';
import { perPageList, toolPanelDefault } from '@/configs/tableConfigs';
import { TTableVisiblePayload } from '@/components/table/types';
import { TTableColumns } from '@/components/table/types';
import TableService from '@/services/TableService';

export default Vue.extend({
  name: 'TableToolButtonsPanel',
  components: {
    TableToolTotalRow,
    TableToolPerPage,
    TableToolColumns,
  },

  props: {
    columnsData: {
      type: Array as PropType<TTableColumns>,
      required: false,
      default: () => [],
    },
    buttons: {
      type: Array as PropType<Array<string>>,
      required: false,
      default: toolPanelDefault, // totalRow | perPage | optionalColumns
    },
    perPageData: {
      type: Number,
      required: false,
      default: perPageList()[0].value,
    },
  },

  watch: {
    columnsData: {
      handler(newValue: TTableColumns) {
        this.columns = newValue;
      },
      immediate: true,
    },
    perPageData(newValue: number) {
      this.perPage = newValue;
    },
  },

  methods: {
    checkToolPanel(value: string): boolean {
      if (Array.isArray(this.buttons)) {
        return this.buttons.includes(value);
      }
      return false;
    },
    changeTotalRow(totalRowActive: boolean) {
      this.totalRowActive = totalRowActive;
    },
    changePerPage(perPage: number) {
      this.perPage = perPage;
      this.$emit('changePerPage', this.perPage);
    },
    changeActiveColumn(payload: TTableVisiblePayload) {
      this.columns = TableService.changeActiveColumn(this.columns, payload);
    },
  },

  data() {
    return {
      columns: [] as TTableColumns,
      totalRowActive: false,
      perPage: perPageList()[0].value as number,
      sortedColumn: '',
    };
  },
});
